import React from 'react';
import Frame from "../common/Frame";
import Footer from "../common/Footer";
import {useTranslation} from "react-i18next";
import {appdata} from "../../logic_tmp/appdata/AppData";

export function ThankYouLead() {
    const { t } = useTranslation();
    // @ts-ignore
    return (
        <div>
            <Frame>
                <h2 className="offer-pay__title">
                    {t("ThankYouISentAConfirmationToYouEmailWithSmallGift!",{email:appdata.customerEmail})}
                </h2>
                <Footer></Footer>
            </Frame>
        </div>
    );
}
